import { z } from 'zod';
import superjson from 'superjson';
export const schema = z.object({
  id: z.string().min(1),
  name: z.string().min(1).max(100).optional(),
  description: z.string().max(500).optional().nullable(),
  icon: z.string().min(1).max(50).optional(),
  category: z.string().min(1).max(50).optional(),
  systemPrompt: z.string().min(10).max(5000).optional(),
  priority: z.number().int().min(1).max(100).optional(),
  tags: z.array(z.string().max(30)).max(10).optional().nullable(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  persona: {
    id: string;
    name: string;
    description: string | null;
    icon: string;
    category: string;
    systemPrompt: string;
    isBuiltin: boolean;
    priority: number;
    tags: string[] | null;
  };
};

export const postUpdatePersona = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch('/_api/personas/update', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
